// Fenêtre d’information locale : aucun appel ni transmission de données à Klarna.
class MlKlarnaInformation extends HTMLElement {
  connectedCallback() {
    if (this.closest('product-card, quick-add-dialog, [data-ref="popup-content"]')) {
      this.hidden = true;
      return;
    }
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('.ml-klarna-information__more');
    if (!this.dialog || !this.trigger || !this.dialog.showModal || this.events) return;
    this.events = new AbortController();
    const options = { signal: this.events.signal };
    this.trigger.addEventListener('click', event => {
      event.preventDefault();
      this.wasLocked = document.body.classList.contains('overflow-hidden');
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      this.dialog.scrollTop = 0;
      document.body.classList.add('overflow-hidden');
    }, options);
    this.querySelectorAll('[data-ml-klarna-close]').forEach(button => {
      button.addEventListener('click', () => this.dialog.close(), options);
    });
    this.dialog.addEventListener('click', event => {
      const rect = this.dialog.getBoundingClientRect();
      if (event.target === this.dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
    }, options);
    this.dialog.addEventListener('close', () => {
      this.trigger.setAttribute('aria-expanded', 'false');
      if (!this.wasLocked) document.body.classList.remove('overflow-hidden');
      if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
    }, options);
  }
  disconnectedCallback() {
    if (this.dialog?.open && !this.wasLocked) document.body.classList.remove('overflow-hidden');
    this.events?.abort();
    this.events = null;
  }
}
if (!customElements.get('ml-klarna-information')) customElements.define('ml-klarna-information', MlKlarnaInformation);
